module.exports = __webpack_public_path__ + "static/img/home1-bg3-content.370c1e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home1-bg3-content.png
// module id = N2QO
// module chunks = 0